export default __webpack_public_path__ + "static/media/navbar-faq-orange.4a9a1f71.svg";